export const MIN_SEARCH_LENGTH = 3;

export type SearchState = 'idle' | 'loading' | 'error' | 'empty' | 'results';

type SearchStateParams = {
  searchText: string | undefined;
  resultsCount: number;
  isDebouncing: boolean;
  isFetching: boolean;
  isError: boolean;
};

// Keeps previous results visible while refetching (DESIGN.md §5 data fetch tier).
export const resolveSearchState = ({
  searchText,
  resultsCount,
  isDebouncing,
  isFetching,
  isError,
}: SearchStateParams): SearchState => {
  if (!searchText || searchText.trim().length < MIN_SEARCH_LENGTH) return 'idle';
  if (isError) return 'error';
  if (resultsCount > 0) return 'results';
  if (isDebouncing || isFetching) return 'loading';
  return 'empty';
};
